<div class="complex-filter-date-range">
  <form class="form">
    <div class="complex-filter-date-range__container">
      <ftr-date-picker
        label="From"
        [control]="asFormControl(internalFormGroup.controls['dateRangeFrom'])"
      ></ftr-date-picker>
      <ftr-date-picker
        label="To"
        [control]="asFormControl(internalFormGroup.controls['dateRangeTo'])"
      ></ftr-date-picker>
    </div>
  </form>
</div>
